import React from 'react';
import './StepNumber.css';
function StepNumber(_ref) {
  var stepNumber = _ref.stepNumber;
  return /*#__PURE__*/React.createElement("div", {
    className: "rounded-step-number"
  }, stepNumber);
}
export default StepNumber;